import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import SubscriptionService from '@/services/SubscriptionService';
import Loading from '@/components/widget/Loading';
import PayBalance from '@/components/billing/PayBalance';
import Info from '@/components/subscriptions/Info';
import SubscriptionTypeInfo from '@/components/subscriptiontypes/Info';
import Cancel from '@/components/subscriptions/Cancel';
import Change from '@/components/subscriptions/Change';
export default {
  name: 'Subscription',
  components: {
    Loading,
    PayBalance,
    Info,
    Cancel,
    Change,
    SubscriptionTypeInfo
  },
  data: () => {
    return {
      loading: false,
      openedRenewModal: false,
      accountStatus: null,
      subscription: null,
      types: [],
      states: [],
      countries: [],
      isAdmin: false
    };
  },
  created: function () {
    this.init();
  },
  methods: {
    init() {
      this.loading = true;
      SubscriptionService.init().then(response => {
        this.subscription = response.data.subscription;
        this.states = response.data.states;
        this.countries = response.data.countries;
        if (typeof response.data.types !== 'undefined' && response.data.types !== null && response.data.types !== false && response.data.types.length > 0) {
          this.types = response.data.types;
        }
        if (typeof response.data.accountStatus !== 'undefined' && response.data.accountStatus !== null && response.data.accountStatus !== false) {
          this.accountStatus = response.data.accountStatus;
        }
        if (typeof response.data.isAdmin !== 'undefined' && response.data.isAdmin !== null && response.data.isAdmin !== false) {
          this.isAdmin = response.data.isAdmin;
        }
        /* trigger upgrade/switch modal if no valid subscription is found *
        if (!this.subscription || !this.subscription.id) {
          if (!this.openedRenewModal) {
            // $scope.fn.upgrade(null, true);
          }
          this.openedRenewModal = true;
        } */
      }).catch(error => {
        this.$aim.error(error.response);
      }).finally(() => {
        this.loading = false;
      });
    }
  },
  computed: {
    balanceDue() {
      return this.accountStatus ? this.accountStatus.balance : 0;
    },
    isCurrent() {
      return this.subscription && this.subscription.current === 1;
    },
    filteredTypes: function () {
      return this.types.filter(e => {
        return this.isCurrent ? e.id !== this.subscription.subscriptiontype_id : true;
      });
    }
  },
  filters: {
    billingType: function (value) {
      return value > 1 ? 'Annually' : value ? 'Monthly' : 'Once';
    }
  }
};